import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      id: 1,
      icon: 'Shield',
      title: 'SSL Ativo',
      description: 'Seus dados são criptografados e seguros'
    },
    {
      id: 2,
      icon: 'Lock',
      title: 'Privacidade de Dados',
      description: 'Proteção de dados em conformidade com a LGPD/GDPR'
    },
    {
      id: 3,
      icon: 'CheckCircle',
      title: 'Conformidade Política',
      description: 'Atende às regulamentações de dados políticos'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <h3 className="text-sm font-medium text-muted-foreground text-center mb-4">
        Plataforma Confiável e Segura
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {trustBadges?.map((badge) => (
          <div
            key={badge?.id}
            className="flex flex-col items-center text-center p-3 rounded-lg bg-muted/50"
          >
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mb-2">
              <Icon name={badge?.icon} size={20} className="text-primary" />
            </div>
            <h4 className="text-xs font-medium text-foreground mb-1">
              {badge?.title}
            </h4>
            <p className="text-xs text-muted-foreground leading-tight">
              {badge?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;